import Vue from 'vue'

import SiteHeaderComponent from '@/components/common/site-header';
Vue.component('site-header-component', SiteHeaderComponent)

import BreadcrumbsComponent from '@/components/common/breadcrumbs'
Vue.component('breadcrumbs-component', BreadcrumbsComponent)

import FooterComponent from '@/components/common/footer'
Vue.component('footer-component', FooterComponent)